import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IOpcionesRequest, 
  IOpcionesResponse 
} from '../interfaces/opciones.interface';

@Injectable({
  providedIn: 'root'
})
export class OpcionesService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetActividad`;

  constructor(private http: HttpClient) { }

  getOpciones(request: IOpcionesRequest): Observable<IOpcionesResponse> {
    return this.http.post<IOpcionesResponse>(this.API_URL, request);
  }

  getEstatus(): Observable<IOpcionesResponse> {
    const payload: IOpcionesRequest = { sTabla: 'cianeg', sCampo: 'Estatus' };
    return this.http.post<IOpcionesResponse>(this.API_URL, payload);
  }

  getEstados(): Observable<IOpcionesResponse> {
    const payload: IOpcionesRequest = { sTabla: 'estados', sCampo: 'cve_estado' };
    return this.http.post<IOpcionesResponse>(this.API_URL, payload);
  }
} 